import create from 'zustand';
import { Flavor } from '../types';

type FlavorStore = {
  flavor: Flavor,
  set: (f: Flavor) => void
}

const useFlavorStore = create<FlavorStore>(set => ({
  flavor: "apple",
  set: f => set(() => ({ flavor: f }))
}));

export default useFlavorStore;
